const SUPER_GROUP_LABELS = {
  VACCINE: "Collection Charge",
  HORMONE: "Hormone",
  PATH: "Path",
  XRAY: "X-Ray",
  ECG: "ECG",
  USG: "USG",
  ECHO: "Echo",
};

export const getSuperGroupName = (name) => {
  if (!name) return "";
  const key = name.toString().trim().toUpperCase();
  if (SUPER_GROUP_LABELS[key]) return SUPER_GROUP_LABELS[key];
  const raw = name.toString().trim();
  if (!raw) return "";
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
};
